<template>
  <div>
    <main class="Game">
      <div class="user-info">
        <div class="role-wrapper">
          <p>{{ state.context.selectedZone.zone_name }} - {{ state.context.selectedRole.name }}</p>
        </div>
        <!--      <p class="change-map">切换</p>-->
      </div>
      <p class="page-time">{{state.context.gameConfig.pageTimeTips}}</p>
      <p class="page-tip" v-if="canShowFreeTask">
        <span>{{ state.context.gameConfig && state.context.gameConfig.tips && state.context.gameConfig.tips.getChance ? state.context.gameConfig.tips.getChance : "对局一次，可免费走第一步，概率得史诗皮肤" }}</span>
        <span @click="openFightTask()">去获得>>></span>
      </p>

      <div class="logo"></div>

      <div class="Game_senior" v-if="state.context.selectedMap==map.SENIOR">
        <div class="bg-top"></div>
        <div class="bg-bottom"></div>
        <div class="bg-logo"></div>

        <ToolBar :state="state" :send="send"></ToolBar>

        <div class="Game_board">
          <div class="tabs">
            <div class="tab" @click="switchMap(map.JUNIOR)">
              <em class="btn-eazy">初级地图</em>
              <em class="tag tag--style">开史诗皮肤（免费一次）</em>
            </div>
            <div class="divider"></div>
            <div class="tab primary" @click="switchMap(map.SENIOR)">
              <em class="btn-senior">进阶地图</em>
              <em class="tag">开传说皮肤</em>
            </div>
          </div>
          <BigPrizeBox :state="state" :send="send" :map="map.SENIOR"></BigPrizeBox>
        </div>

        <div class="Game_center">
          <!-- 路径到哪添加 current -->
          <!-- 已开过的添加 light 亮起光圈 -->
          <div class="box box-1" :class="{'light':isBoxLight(map.SENIOR,1)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:1})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,1)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
          </div>
          <div class="box box-2" :class="{'light':isBoxLight(map.SENIOR,2)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:2})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,2)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
          </div>
          <div class="box box-3" :class="{'light':isBoxLight(map.SENIOR,3)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:3})"></span>
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,3)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
          </div>
          <div class="box box-4" :class="{'light':isBoxLight(map.SENIOR,4)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:4})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,4)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>
          <div class="box box-5" :class="{'light':isBoxLight(map.SENIOR,5)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:5})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,5)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>
          <div class="box box-6" :class="{'light':isBoxLight(map.SENIOR,6)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:6})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,6)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>
          <div class="box box-7" :class="{'light':isUltimateBoxLight(map.SENIOR)}">
            <span class="box-img-b" @click="send('CLICK_PRESENT',{present_rank:7})"></span>
            <div class="box-txt">
              <!-- <p>终极大奖</p>
              <p>冠军飞将皮肤免费抽</p>
              <p>解锁6步免费送</p> -->
            </div>
            <img class="dkq" v-if="hasUnusedCoupon(map.SENIOR,7)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>

          <!-- 头像偏移动画 class: an1 an2 an3... -->
          <div class="user animation" v-if="state.context.taskInfo"
               :class="{
                'an1':getCurrentLocation(map.SENIOR,1),
                'an2':getCurrentLocation(map.SENIOR,2),
                'an3':getCurrentLocation(map.SENIOR,3),
                'an4':getCurrentLocation(map.SENIOR,4),
                'an5':getCurrentLocation(map.SENIOR,5),
                'an6':getCurrentLocation(map.SENIOR,0)
          }">
            <div class="avatar-box" v-if="state.context.userInfo && state.context.userInfo.avatar">
              <img class="avatar" :src="state.context.userInfo.avatar"/>
            </div>
          </div>
        </div>

        <div class="Game_btns">
          <button class="lottery-btn primary" v-html="state.context.gameConfig.products.find(item=>item.product_id=='1450019044_EMPTY_2850').btn_text" @click="buy('1450019044_EMPTY_2850')">

          </button>
          <button class="lottery-btn" v-html="state.context.gameConfig.products.find(item=>item.product_id=='1450019044_EMPTY_500').btn_text" @click="buy('1450019044_EMPTY_500')">

          </button>
        </div>
      </div>

      <div class="Game_eazy" v-if="state.context.selectedMap==map.JUNIOR">
        <div class="bg-top"></div>
        <div class="bg-right"></div>
        <div class="bg-bottom"></div>
        <div class="bg-logo"></div>

        <ToolBar :state="state" :send="send"></ToolBar>

        <div class="Game_board">
          <div class="tabs">
            <div class="tab primary" @click="switchMap(map.JUNIOR)">
              <em class="btn-eazy">初级地图</em>
              <em class="tag tag--style">开史诗皮肤（免费一次）</em>
            </div>
            <div class="divider"></div>
            <div class="tab" @click="switchMap(map.SENIOR)">
              <em class="btn-senior">进阶地图</em>
              <em class="tag">开传说皮肤</em>
            </div>
          </div>
          <BigPrizeBox :state="state" :send="send" :map="map.JUNIOR"></BigPrizeBox>
        </div>

        <div class="Game_center">
          <!-- 路径到哪添加 current -->
          <!-- 已开过的添加 light 亮起光圈 -->
          <div class="box box-1" :class="{'light':isBoxLight(map.JUNIOR,1)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:1})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,1)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
          </div>
          <div class="box box-2" :class="{'light':isBoxLight(map.JUNIOR,2)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:2})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,2)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
          </div>
          <div class="box box-3" :class="{'light':isBoxLight(map.JUNIOR,3)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:3})"></span>
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,3)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
          </div>
          <div class="box box-4" :class="{'light':isBoxLight(map.JUNIOR,4)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:4})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,4)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>
          <div class="box box-5" :class="{'light':isBoxLight(map.JUNIOR,5)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:5})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,5)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>
          <div class="box box-6" :class="{'light':isBoxLight(map.JUNIOR,6)}">
            <span class="box-img" @click="send('CLICK_PRESENT',{present_rank:6})"></span>
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,6)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>
          <div class="box box-7" :class="{'light':isUltimateBoxLight(map.JUNIOR)}">
            <span class="box-img-b" @click="send('CLICK_PRESENT',{present_rank:7})"></span>
            <div class="box-txt box-txt--style">
              <!-- <p>终极大奖</p>
              <p>冠军飞将皮肤免费抽</p>
              <p>解锁6步免费送</p> -->
            </div>
            <img class="dkq" v-if="hasUnusedCoupon(map.JUNIOR,7)"
                 src="../../../../ui/20201111king_double_eleven/assets/dkq.png" alt="">
            <img class="ckbx" v-else src="../../../../ui/20201111king_double_eleven/assets/ckbx.png" alt="">
            <!-- <img class="dkq" src="./assets/dkq.png" alt=""> -->
          </div>

          <!-- 头像偏移动画 class: an1 an2 an3... -->
          <div class="user animation" v-if="state.context.taskInfo"
               :class="{
                'an1':getCurrentLocation(map.JUNIOR,1),
                'an2':getCurrentLocation(map.JUNIOR,2),
                'an3':getCurrentLocation(map.JUNIOR,3),
                'an4':getCurrentLocation(map.JUNIOR,4),
                'an5':getCurrentLocation(map.JUNIOR,5),
                'an6':getCurrentLocation(map.JUNIOR,0)
          }">
            <div class="avatar-box" v-if="state.context.userInfo && state.context.userInfo.avatar">
              <img class="avatar" :src="state.context.userInfo.avatar"/>
            </div>
          </div>
        </div>

        <div class="Game_btns">
          <button v-html="state.context.gameConfig.products.find(item=>item.product_id=='1450019044_EMPTY_6').btn_text" class="lottery-btn primary" @click="buy('1450019044_EMPTY_6')">

          </button>
          <button class="lottery-btn" v-html="state.context.gameConfig.products.find(item=>item.product_id=='1450019044_EMPTY_1').btn_text" @click="buy('1450019044_EMPTY_1')">
          </button>
        </div>
      </div>

      <!-- loading -->
      <div class="MIDAS-TOAST-loading MIDAS-TOAST-loading-index" v-if="isShowLoading">
        <i class="MIDAS-TOAST-loading__icon icon-load"></i>
        <p class="MIDAS-TOAST-loading__txt">加载中，请稍候...</p>
      </div>
    </main>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
import * as configs from "../configs"
import BigPrizeBox from "../components/BigPrizeBox.vue"
import ToolBar from "../components/ToolBar.vue"

export default {
  name: "Main",
  props: ["state", "send"],

  components: {
    BigPrizeBox,
    ToolBar
  },

  setup(props) {
    const map = configs.MAP

    const canShowFreeTask = computed(() => {
      // 是否可以展示免费任务：
      // 1. 低级地图
      // 2. 任务积分小于1，即只能在第一步领取
      return (
        props.state.context.selectedMap == map.JUNIOR &&
        props.state.context &&
        props.state.context.taskInfo &&
        props.state.context.taskInfo.total_score < 1
      )
    })

    const isShowLoading = computed(() => {
      return [
        "participate.fight.freetask.checking",
        "participate.fight.freetask.checkSuccess.complete.receiving",
        "participate.orderAndFight.select.alert.selectfreetask.checking",
        "participate.orderAndFight.select.alert.selectfreetask.checkSuccess.complete.receiving",
        "participate.pay.placeOrder.pending",
        "participate.pay.payment.pending"
      ].some(props.state.matches)
    })

    const buy = productid => {
      // 无论游戏内还是游戏外，都需要弹窗让用户确认是否领取免费任务
      // 如果可以显示免费对战且在游戏内，则弹窗让用户选择领取免费任务还是支付
      //    && props.state.context.userAgent.msdk
      if (canShowFreeTask.value) {
        props.send("SELECT_ORDER_OR_FIGHTTASK", props.state.context.gameConfig.products.find(item => item.product_id == productid))
      } else {
        props.send("PLACE_ORDER", props.state.context.gameConfig.products.find(item => item.product_id == productid))
      }
    }

    const switchMap = level => {
      props.send("SWITCH_MAP", { level })
    }

    // 按照地图以及宝箱展示用户的奖池信息
    const showPrizeList = rank => {
      props.send("FETCH_PRIZE_LIST", {
        rank
      })
    }

    const getCurrentLocation = (map, rank) => {
      return (
        props.state.context.selectedMap == map &&
        props.state.context.taskInfo.total_score > 0 &&
        props.state.context.taskInfo.total_score % 6 == rank
      )
    }

    const isBoxLight = (map, rank) => {
      return props.state.context.selectedMap == map && props.state.context.taskInfo.total_score % 6 > rank
    }

    const isUltimateBoxLight = map => {
      return props.state.context.selectedMap == map && props.state.context.taskInfo.total_score % 6 == 0
    }

    const hasUnusedCoupon = (map, rank) => {
      const groupid = props.state.context.gameConfig.drawGroupid[map].find(item => item.rank == rank).groupid

      return props.state.context?.unusedCoupon?.[map]?.[groupid]?.length > 0
    }

    const openFightTask = () => {
      props.send("SHOW_FIGHTTASK", {})
    }

    return {
      map,
      canShowFreeTask,
      isShowLoading,
      buy,
      switchMap,
      openFightTask,
      showPrizeList,

      isBoxLight,
      isUltimateBoxLight,
      getCurrentLocation,
      hasUnusedCoupon
    }
  }
}
</script>

<style scoped>
</style>
